<!-- Content -->
<div class="container">
  <div class="row">
    <div class="offset-md-4 col-md-4 login-panel">
      <div class="card bg-light">
        <div class="card-header">
          <h3 class="card-title m-0">{{ 'sign_in' | translate }}</h3>
        </div>
        <div class="card-body">
          <button class="mdsf-btn mdsf-btn-secondary btn-block mb-2 flex justify-content-center align-items-center gap-2"
                  type="button"
                  (click)="login()">
            <img src="assets/images/iml_logo.png" width="24" alt="Login">
            <span>IML Auth</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

